import React from "react";
import type { CardType } from "../types/types";

export const CurrentCardContext = React.createContext({} as CardType);
